import { PaymentMethod, PaymentTransferType } from "../generated/graphql"
import { getPaymentMethodType } from "./getPaymentMethodType"

/**
 * Spiegel des Server-Guards `isPaymentMethodUsableForBooking` (ko-X-main, B-82808):
 * false nur für Lastschrift-Methoden (per Klassifikator oder gespeichertem Typ) ohne
 * Kontoinhaber oder IBAN. Die leere Platzhalter-Methode des Checkouts ist damit
 * anlegbar und aufklappbar, aber nicht buchbar.
 */
export const isPaymentMethodUsableForBooking = (paymentMethod: Partial<PaymentMethod>): boolean => {
    const isSepaDebit = getPaymentMethodType(paymentMethod) === "sepaDebit" || paymentMethod.type === PaymentTransferType.SepaDebit

    return !isSepaDebit || ((paymentMethod.sepaAccountholder ?? "").trim() !== "" && (paymentMethod.iban ?? "").trim() !== "")
}
